export const IFRAME_SANDBOX = 'allow-scripts';
export const IFRAME_ALLOW_PERMISSIONS = 'clipboard-read; clipboard-write';
